/* TinyPagePreview.js */

import React from 'react';
import { Col, Row } from 'reactstrap';
import '../../assets/components/tiny_page_preview.scss';
import Strings from '../../translations/Translations';
import RemixShare from './RemixShare';
import PlayIcon from '../../assets/img/play_icon.svg';
import { getRemixCover } from '../../helpers/GetRemixCover';

export default function TinyPagePreview({ skin, createMode, editMode, remix, links, title = '', description = '', playRemixCallback, playerCallback }) {

  return (
    <div className='mx-5 p-4'>

      <Row>
        <Col className='d-flex justify-content-center'>
          <div className={`device-frame shadow-lg ${(skin) ? `tbg${skin}` : '' } `}>
            <div className='title'>
              <div className='text-crop'>
                {title}
              </div>
            </div>
            <div
              className={`video d-flex justify-content-center align-items-center rounded shadow pb-video-create-1 ${(editMode) ? 'edit' : 'create cursor-pointer'}`}
              onClick={() => { if (playerCallback) { playerCallback(); } }}
            >
              {editMode && remix && (
                <img
                  src={getRemixCover(remix)}
                  alt={remix.rde}
                  title={remix.rti}
                />
              )}
              <div className='text-center'>
                <img
                  src={PlayIcon}
                  alt='Play icon'
                  className={`${(editMode) ? 'cursor-pointer': ''}`}
                  onClick={playRemixCallback}
                />
              </div>
            </div>
            <div className='description'>
              <div className='line-clamp'>
                {description}
              </div>
            </div>
            <div className='links'>
              {links && links.length > 0 && links.map((link) => (
                <a key={link.id} href={link.url} rel='noreferrer noopener nofollow' target='_blank'>
                  <div className='text-crop'>
                    {link.label}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      {editMode && (
        <Row className='mt-3'>
          <Col sm={12} className='d-flex justify-content-center mb-2 text-muted'>
            <span>{Strings('share')}</span>
          </Col>

          <Col sm={12}>
            <RemixShare
              remix={remix}
              groupButtons={false}
              align='center'
              btnClass='pb-m-1'
            />
          </Col>
        </Row>
      )}

    </div>
    
  );
}
